exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box-header .box-title{font-size:15px;font-weight:700}.form-vertical .editorGroup:not(:last-child){padding-bottom:5px}.fieldGroupMutiRow label{padding-left:5px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/FormItemFieldGroupStyle.css
// module id = 301
// module chunks = 1 2 3 4 5 7